import { useEffect, useRef } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { GoogleG, Logo } from './Logo';

export function Login() {
  const { googleReady, renderButton, configError } = useAuth();
  const slotRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (googleReady && slotRef.current) renderButton(slotRef.current);
  }, [googleReady, renderButton]);

  return (
    <div className="cw-login-wrap">
      <div className="cw-login-card">
        <Logo className="cw-login-logo" />
        <div className="cw-login-sub">Performance Dashboard</div>
        <div className="cw-rule" />

        <div className="cw-login-btnslot" ref={slotRef}>
          {!googleReady && (
            <button className="cw-google-btn" disabled aria-busy="true">
              <GoogleG />
              <span>Mit Google anmelden</span>
            </button>
          )}
        </div>

        {configError && <div className="cw-login-error">{configError}</div>}
        <div className="cw-login-note">Zugang nur für das Cosyworld-Team</div>
      </div>
    </div>
  );
}
